import { createSelector, createSelectorMemoized } from '@base-ui/utils/store';
export const EVENT_TIMELINE_PREMIUM_VIEW_CONFIGS = {
  time: {
    unitCount: 4,
    // 4 days
    getStartDate: (adapter, visibleDate) => adapter.startOfDay(visibleDate),
    getEndDate: (adapter, start, unitCount) => adapter.endOfDay(adapter.addDays(start, unitCount - 1)),
    // Each CSS unit is 1 hour (--time-cell-width), so we need days × 24 hours
    getCssUnitCount: () => 4 * 24
  },
  days: {
    unitCount: 8 * 7,
    // 8 weeks
    getStartDate: (adapter, visibleDate) => adapter.startOfDay(visibleDate),
    getEndDate: (adapter, start, unitCount) => adapter.endOfDay(adapter.addDays(start, unitCount - 1))
  },
  weeks: {
    unitCount: 16,
    // 16 weeks
    getStartDate: (adapter, visibleDate) => adapter.startOfWeek(visibleDate),
    getEndDate: (adapter, start, unitCount) => adapter.endOfWeek(adapter.addWeeks(start, unitCount - 1))
  },
  months: {
    unitCount: 3 * 12,
    // 3 years
    getStartDate: (adapter, visibleDate) => adapter.startOfMonth(visibleDate),
    getEndDate: (adapter, start, unitCount) => adapter.endOfMonth(adapter.addMonths(start, unitCount - 1)),
    getCssUnitCount: (adapter, start, end) => adapter.differenceInDays(end, start) + 1
  },
  years: {
    unitCount: 30,
    // 30 years
    getStartDate: (adapter, visibleDate) => adapter.startOfYear(visibleDate),
    getEndDate: (adapter, start, unitCount) => adapter.endOfYear(adapter.addYears(start, unitCount - 1))
  }
};
export const eventTimelinePremiumViewSelectors = {
  view: createSelector(state => state.view),
  views: createSelector(state => state.views),
  config: createSelectorMemoized(state => state.adapter, state => state.visibleDate, state => state.view, (adapter, visibleDate, view) => {
    const {
      getStartDate,
      getEndDate,
      unitCount,
      getCssUnitCount
    } = EVENT_TIMELINE_PREMIUM_VIEW_CONFIGS[view];
    const start = getStartDate(adapter, visibleDate);
    const end = getEndDate(adapter, start, unitCount);
    return {
      unitCount: getCssUnitCount ? getCssUnitCount(adapter, start, end) : unitCount,
      start,
      end
    };
  })
};